/** Kun http(s) åpnes; blokkerer javascript:, data: m.fl. (signerte R2-adresser er https). */
export const erHttpAdresse = (verdi: unknown): verdi is string => {
  if (typeof verdi !== 'string') return false;
  try {
    const { protocol } = new URL(verdi);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
};

/** Åpner adressen i ny fane med noopener,noreferrer, men bare hvis den er http(s). Returnerer om den ble åpnet. */
export const aapneHttpAdresse = (verdi: unknown): boolean => {
  if (!erHttpAdresse(verdi)) return false;
  window.open(verdi, '_blank', 'noopener,noreferrer');
  return true;
};
